// User Types
export const USER_TYPES = {
  TWIZE_ADMIN: 'TWIZE_ADMIN',
  PARTNER_MANAGER: 'PARTNER_MANAGER',
  PARTNER_EMPLOYEE: 'PARTNER_EMPLOYEE',
  CONSUMER: 'CONSUMER'
} as const;

export type UserType = typeof USER_TYPES[keyof typeof USER_TYPES];

// Bank Names
export const BANK_NAMES = [
  { value: 'BFI', label: 'BFI' },
  { value: 'BEA', label: 'BEA' },
  { value: 'BNM', label: 'BNM' },
  { value: 'BPM', label: 'BPM' },
  { value: 'BMCI', label: 'BMCI' }
];

// User Type Options based on logged-in user type
export const USER_TYPE_OPTIONS: Record<string, Array<{value: string, label: string}>> = {
  TWIZE_ADMIN: [
    { value: 'TWIZE_ADMIN', label: 'System Admin' },
    { value: 'PARTNER_MANAGER', label: 'Bank Manager' },
    { value: 'PARTNER_EMPLOYEE', label: 'Bank Employee' }
  ],
  PARTNER_MANAGER: [
    { value: 'PARTNER_EMPLOYEE', label: 'Bank Employee' },
    { value: 'CONSUMER', label: 'Consumer' }
  ],
  PARTNER_EMPLOYEE: [
    { value: 'CONSUMER', label: 'Consumer' }
  ]
};

// Helper Functions
export const getUserTypeOptions = (currentUserType: string) => {
  return USER_TYPE_OPTIONS[currentUserType] || [];
};

export const showCredentialFields = (selectedUserType: string) => {
  return ['TWIZE_ADMIN', 'PARTNER_MANAGER', 'PARTNER_EMPLOYEE'].includes(selectedUserType);
};

export const canSelectBank = (currentUserType: string) => {
  return currentUserType === 'TWIZE_ADMIN';
};

// Read from build-time environment variable (set during Docker build in Coolify)
export const API_BASE_URL = process.env.REACT_APP_API_BASE || process.env.REACT_APP_API_BASE_URL || 'http://localhost:8090/api/v1';

